import React, { Suspense } from 'react';
import { Route, Routes, BrowserRouter as Router  } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import './scss/style.scss';
import 'bootstrap/dist/css/bootstrap.css';
import Spinner from 'react-bootstrap/Spinner';
// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
// Pages
//WIP

function App() {
  return (
    <Router>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Suspense
          fallback={
            <div className="pt-3 text-center">
              <Spinner animation="border" variant="primary" />
            </div>
          }
          >
          <Routes>
            <Route path="*" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </LocalizationProvider>
    </Router>
  );
}

export default App;
